// extracted by mini-css-extract-plugin
module.exports = {"box":"LoanPurposes_box__Q-Spf","content":"LoanPurposes_content__2p0M7"};